import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { SectionHeading } from "@/components/SectionHeading";
import { TESTIMONIALS } from "@/data/content";

export const TestimonialsDark = () => {
  const [i, setI] = useState(0);
  const go = (d) => setI((prev) => (prev + d + TESTIMONIALS.length) % TESTIMONIALS.length);
  const t = TESTIMONIALS[i];

  return (
    <section className="relative noise-overlay" data-testid="testimonials-section">
      <div className="relative z-10 max-w-[1500px] mx-auto px-6 md:px-12 py-14 md:py-24">
        <SectionHeading label="What our clients say" title="Words that measure our work." />

        <div className="mt-14 grid grid-cols-1 items-end gap-10 lg:grid-cols-12">
          <div className="lg:col-span-9">
            <span className="font-display text-8xl leading-none text-brand-magenta/30">&ldquo;</span>
            <AnimatePresence mode="wait">
              <motion.blockquote
                key={i}
                drag="x"
                dragConstraints={{ left: 0, right: 0 }}
                dragElastic={0.18}
                onDragEnd={(e, info) => {
                  if (info.offset.x < -80) go(1);
                  else if (info.offset.x > 80) go(-1);
                }}
                initial={{ opacity: 0, y: 24 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -24 }}
                transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
                className="mt-2 cursor-grab active:cursor-grabbing"
                data-testid="testimonial-quote"
              >
                <p className="font-heading font-bold tracking-tight text-brand-ink text-xl md:text-3xl leading-snug">
                  {t.quote}
                </p>
                <footer className="mt-8 text-sm uppercase tracking-[0.2em] text-brand-ink/70">
                  {t.name} · {t.role}
                </footer>
              </motion.blockquote>
            </AnimatePresence>
          </div>

          <div className="flex items-center gap-4 lg:col-span-3 lg:flex-col lg:items-end">
            <div className="flex gap-3">
              <button
                onClick={() => go(-1)}
                data-testid="testimonial-prev"
                aria-label="Previous testimonial"
                className="flex h-14 w-14 items-center justify-center rounded-full border border-brand-ink/15 text-brand-ink transition-colors duration-300 hover:bg-brand-primary hover:text-white"
              >
                <ArrowLeft className="h-5 w-5" />
              </button>
              <button
                onClick={() => go(1)}
                data-testid="testimonial-next"
                aria-label="Next testimonial"
                className="flex h-14 w-14 items-center justify-center rounded-full border border-brand-ink/15 text-brand-ink transition-colors duration-300 hover:bg-brand-primary hover:text-white"
              >
                <ArrowRight className="h-5 w-5" />
              </button>
            </div>
            <p className="self-center font-semibold tabular-nums text-brand-ink/70">
              {String(i + 1).padStart(2, "0")} / {String(TESTIMONIALS.length).padStart(2, "0")}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
